// extracted by mini-css-extract-plugin
module.exports = {"classMenu":"ClassificationList_classMenu__16zcG","title":"ClassificationList_title__33sxM"};